import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box } from '@mui/material'
import { useLocation } from 'react-router-dom'

import TextField from 'components/global/CUK/TextField'

import { useFilters } from '../../store'

const TextFilter = () => {
  const [filters, setFilters] = useFilters()
  const { t } = useTranslation()
  const location = useLocation()
  const hasVerbatimFilter = Boolean(filters.verbatim)

  const handleChangeVerbatim = newValue => {
    setFilters(prev => ({ ...prev, verbatim: newValue }))
  }

  const handleClearVerbatim = () => {
    setFilters(prev => ({ ...prev, verbatim: '' }))
  }

  return (
    <Box
      sx={{
        display: 'flex',
        width: 'clamp(120px, 300px, 320px)'
      }}>
      <TextField
        value={filters.verbatim}
        setvalue={handleChangeVerbatim}
        sx={{ width: '30vh' }}
        type="text"
        input={{
          placeholder:
            location.pathname.indexOf('/monitoring/sites') === 0
              ? t('supervision.filters.site_name_placeholder')
              : location.pathname.indexOf('/monitoring/ssids') === 0
                ? t('supervision.filters.site_ssid_name_placeholder')
                : location.pathname.indexOf('/monitoring/map') === 0
                  ? t('supervision.filters.site_name_placeholder')
                  : t('supervision.filters.label_mac_address'),
          starticon: <i className={'fa-light fa-search'} />,
          endicon: hasVerbatimFilter ? <i className={'fa-light fa-xmark'} /> : null,
          endiconchange: hasVerbatimFilter ? handleClearVerbatim : null
        }}
      />
    </Box>
  )
}

export default TextFilter
